/**
 * PREPARAR A TELA — o que o tour garante antes de apontar para um elemento.
 *
 * Quem entra pela primeira vez cai no Hub ("Sua planta, orquestrada."), que não
 * tem campo de mensagem. Medido no deploy real (E2E, develop.axiomgo.io). Os
 * passos do microfone, da barra e das perguntas prontas só existem dentro de uma
 * conversa; este helper abre uma, pelo mesmo botão que a pessoa usaria.
 */
import { esperarElemento } from './esperar-elemento'

export const CAMPO_DA_MENSAGEM = '[data-testid="chat-input"]'
export const BOTAO_NOVA_CONVERSA = '[data-testid="new-conversation-btn"]'
export const BARRA_LATERAL = '[data-testid="sidebar"]'

/** Devolve `true` quando o campo de mensagem está na tela (abrindo uma conversa se preciso). */
export async function garantirConversaAberta(esperaMs = 8000): Promise<boolean> {
  // Logo depois de navegar (ex.: da Equipe de volta ao chat) a tela ainda está montando: espera
  // o campo OU o botão de nova conversa, o que aparecer primeiro.
  const primeiro = await esperarElemento(`${CAMPO_DA_MENSAGEM}, ${BOTAO_NOVA_CONVERSA}`, esperaMs)
  if (!primeiro) return false
  if (document.querySelector(CAMPO_DA_MENSAGEM)) return true
  document.querySelector<HTMLElement>(BOTAO_NOVA_CONVERSA)?.click()
  return (await esperarElemento(CAMPO_DA_MENSAGEM, esperaMs)) !== null
}

/** Leva o foco ao campo de mensagem (passos que pedem para digitar nele). */
export function focarCampoDaMensagem(): void {
  document.querySelector<HTMLElement>(CAMPO_DA_MENSAGEM)?.focus()
}
